import './NoticeSignUpDataError.css';
export default function NoticeSignUpDataError() {
	return <div className="noticeSignUpDataError">Please check data again </div>;
}
